var exports = {
  "x": "ViolationsListSummary__bYr782",
};

module.exports = exports;
